<template>
  <div class="add-user wrapper">
    <div class="content-page">
      <div class="content">
        <div class="row" style="margin-bottom: 20px;">
          <div class="col-xl-6">用户管理</div>
          <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
            <Breadcrumb></Breadcrumb>
          </div>
        </div>
        <el-card>
          <div class="explain">{{actionType}}<span style="color: red;" v-if="actionType==='修改用户'">（密码不填为不修改密码！）</span></div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登录名" prop="username">
                  <el-input :disabled="actionType==='修改用户'" placeholder="6-16位,不含特殊字符" v-model="ruleForm.username"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="realName">
                  <el-input v-model="ruleForm.realName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登录密码" prop="password">
                  <el-input show-password v-model="ruleForm.password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="确认密码" prop="verifyPassword">
                  <el-input show-password v-model="ruleForm.verifyPassword"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idCard">
                  <el-input v-model="ruleForm.idCard"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出生日期" prop="birthday">
                  <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.birthday" type="date" placeholder="选择出生日期"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Email" prop="email">
                  <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="办公电话" prop="phone">
                  <el-input placeholder="请输入021-XXXXXXX格式" v-model="ruleForm.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="手机" prop="mobile">
                  <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别" prop="sex">
                  <el-select v-model="ruleForm.sex" clearable placeholder="请选择">
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="行政职务" prop="administrativePost">
                  <el-input v-model="ruleForm.administrativePost"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称" prop="professionalSkillPostId">
                  <el-select v-model="ruleForm.professionalSkillPostId" clearable placeholder="请选择">
                    <el-option v-for="item in jobTitleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 新增用户信息字段 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="民族" prop="nation">
                  <el-input v-model="ruleForm.nation"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮政编码" prop="postalCode">
                  <el-input v-model="ruleForm.postalCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="研究专长" prop="areasSpecialization">
                  <el-input v-model="ruleForm.areasSpecialization"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最后学历" prop="lastDegreeId">
                  <el-select v-model="ruleForm.lastDegreeId" clearable placeholder="请选择">
                    <el-option v-for="(item, index) in lastDegreeOptions" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="最后学位" prop="lastQualificationId">
                  <el-select v-model="ruleForm.lastQualificationId" clearable placeholder="请选择">
                    <el-option v-for="(item, index) in lastQualificationOptions" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="通讯地址" prop="address">
                  <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 新增用户信息字段结束 -->

            <el-form-item label="所在单位" prop="unitId">
              <el-cascader v-model="ruleForm.regionId" clearable :props="{ value: 'id', label: 'name' }" :options="areaOptions" @change="areaChange"></el-cascader>
              <el-select v-model="ruleForm.unitId" :disabled="unitOptions.length===0" clearable filterable placeholder="请选择">
                <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="照片" prop="headImage">
                  <UpLoadImgOne @img-event="e => changeData('headImage', e)" :value="ruleForm.headImage"></UpLoadImgOne>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否禁用" prop="state">
                  <el-switch v-model="ruleForm.state" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch><span style="margin-left: 10px;">{{ruleForm.state == 1?'启用':'禁用'}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="介绍" prop="introduc">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入介绍" v-model="ruleForm.introduc" maxlength="2000" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="选择角色" prop="roleId" v-if="userinfo.roleId.indexOf('1')>=0">
              <el-checkbox-group v-model="ruleForm.roleId">
                <el-checkbox :label="item.id" v-for="(item, index) in roleList" :key="index">{{item.roleName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

          </el-form>
          <div class="btn-wrap" style="text-align: center;">
            <el-button size="small" type="primary" @click="newUser">保存</el-button>
            <el-button size="small" type="primary" @click="goBack">返回</el-button>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb.vue";
import UpLoadImgOne from "@/components/upLoad/UpLoadImgOne.vue";
import {
  getRoleList,
  getPlatformInformationData,
  getAreaTree,
  getUnitListByArea,
  addUser,
  editUser,
  getUserDetail,
  userIsExists,
} from "@/api/after/systemManagement.js";
export default {
  components: {
    Breadcrumb,
    UpLoadImgOne,
  },
  watch:{
   'ruleForm.regionId':{
     handler:function(newVal,oldVal){
       if(newVal.length){
          this.getUnitListByArea(newVal[newVal.length-1])
       }
      // 
     }
   }
  },
  data() {
    var validateUsername = (rule, value, callback) => {
      if (this.actionType === "修改用户") {
        callback();
      } else {
        let regexp = /^[a-zA-Z0-9]{6,16}$/;
        if (value === "") {
          callback(new Error("请输入登录名"));
        } else if (!regexp.test(value)) {
          callback(new Error("登录名长度为6-16位且只能包含英文字母、数字"));
        } else if (!regexp.test(value)) {
          callback(new Error("登录名重复"));
        } else {
          this.userNameJudgeRepeat(value).then(res => {
            if (!res) {
              callback(new Error('登录名重复'));
            } else {
              callback();
            }
          });
        }
      }
    };

    var validatePassword = (rule, value, callback) => {
      let regexp = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{8,}$/;
      if (this.actionType === "修改用户") {
        if (!value) {
          callback();
        } else if (regexp.test(value)) {
          callback();
        } else {
          callback(new Error("密码至少包括英文、数字或特殊符合组合，不得少于8位"));
        }
      } else {
        if (!value) {
          callback(new Error("请输入密码"));
        } else if (regexp.test(value)) {
          callback();
        } else {
          callback(new Error("密码至少包括英文、数字或特殊符合组合，不得少于8位"));
        }
      }
    };

    var validateVerifyPassword = (rule, value, callback) => {
      if (value === this.ruleForm.password) {
        callback();
      } else {
        callback(new Error("两次密码不同！"));
      }
    };

    var validateIdCard = (rule, value, callback) => {
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (!value) {
        callback();
      } else if (_IDRe18.test(value) || _IDre15.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的身份证号！"));
      }
    };

    var validateEmail = (rule, value, callback) => {
      let regexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的电子邮箱！"));
      }
    };

    var validatePhone = (rule, value, callback) => {
      let regexp = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的固定电话号码！"));
      }
    };

    var validateMobile = (rule, value, callback) => {
      let regexp = /^1[1-9]\d{9}$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号码！"));
      }
    };
    return {
      ruleForm: {
        rank:'',
        username: '',
        realName: '',
        password: '',
        verifyPassword: '',
        idCard: '',
        birthday: '',
        email: '',
        phone: '',
        mobile: '',
        sex: '',
        administrativePost: '',
        professionalSkillPostId: '',
        professionalSkillPostName: '',
        unitId: '',
        headImage: '',
        state: 1,
        introduc: '',
        roleId: [],
        regionId: [],
        nation: '',//汉族
        areasSpecialization: '',//研究专长
        lastDegreeId: '',//最后学历
        lastQualificationId: '',//最后学位
        address: '',//通讯地址
        postalCode: '',//邮政编码
      },
      rules: {
        username: [{ required: true, validator: validateUsername, trigger: 'blur' }],
        password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        realName: [{ required: true, message: '请输入真实姓名！', trigger: 'blur' }],
        verifyPassword: [{ required: true, validator: validateVerifyPassword, trigger: 'blur' }],
        idCard: [{ validator: validateIdCard, trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'blur' }],
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        unitId: [{ required: true, message: '请选择单位!', trigger: 'change' }]
      },
      roleList: [],
      sexOptions: [
        {
          value: 0,
          label: '女'
        },
        {
          value: 1,
          label: '男'
        }
      ],
      jobTitleOptions: [],
      areaOptions: [],
      unitOptions: [],
      actionType: '新建用户',
      userinfo: JSON.parse(sessionStorage.getItem('userInfo') || 'null'),
      lastDegreeOptions: ['高中及以下', '大学专科', '大学本科', '硕士研究生', '博士研究生'],//最后学历
      lastQualificationOptions: ['学士', '硕士', '博士'],//最后学位
    };
  },
  async created() {
    let id = this.$route.query.id
    await this.getRoleList();
    await this.getAreaTree();
    await this.getPlatformInformationData();
    if (id) {
      this.actionType = '修改用户'
      this.getUserDetailById(id)
      this.rules.password[0].required = false
      this.rules.verifyPassword[0].required = false
    }else{
     this.usertype()
    }
    console.log('岳嵩打印用户信息',this.userinfo)
  },
  methods: {
    //判断用户信息来判断新增时需要回显用户的单位区域
    usertype(){
      if(this.userinfo.roleId.indexOf('1') != -1){

      }else{
        //不是系统管理员是学校管理员
         if(this.userinfo.roleId.indexOf('2') != -1){
          //  let data=[207]
          //  data[1]=this.userinfo.regionId
           this.ruleForm.regionId=this.userinfo.regionList
           console.log('this.ruleForm.regionId',this.ruleForm.regionId)
         }
      }
    },
    // 判断用户名重复
    async userNameJudgeRepeat(userName) {
      const res = await userIsExists(userName);
      if (res.code == 200) {
        return res.data
      } else {
        this.$message.error(res.msg);
      }
    },
    zz(){
      console.log()
    },
    // 获取区域树结构
    async getAreaTree() {
      const res = await getAreaTree();
      if (res.code == 200) {
        this.areaOptions = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取职称列表
    async getPlatformInformationData() {
      const res = await getPlatformInformationData(7);
      if (res.code == 200) {
        this.jobTitleOptions = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    // 根据区域ID获取单位列表
    async getUnitListByArea(id) {
      const res = await getUnitListByArea(id);
      if (res.code == 200) {
        console.log('单位列表', res);
        this.unitOptions = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取角色列表
    async getRoleList() {
      const res = await getRoleList();
      if (res.code == 200) {
        console.log('角色列表', res);
        this.roleList = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    changeData(name, data) {
      this.ruleForm[name] = data;
    },
    // 根据ID获取用户详情
    async getUserDetailById(id) {
      const res = await getUserDetail(id)
      if (res.code == 200) {
        console.log('用户详情', res);
        await this.getUnitListByArea(res.data.regionId);
        // 处理角色数据
        if (res.data.roleId) {
          res.data.roleId = res.data.roleId.split(",").map(Number);
        } else {
          res.data.roleId = [];
        }
        // 将职称变成数值
        if (res.data.professionalSkillPostId) {
          res.data.professionalSkillPostId = +res.data.professionalSkillPostId
        }
        res.data.regionId=res.data.regionList
        // 添加确认密码数据
        res.data.verifyPassword = ''
        res.data.password = ''
        this.ruleForm = res.data
        console.log('回显', this.ruleForm);
      } else {
        this.$message.error(res.msg)
      }
    },
    // 新建用户
    newUser() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 深拷贝数据以免影响表单展示
          let formData = JSON.parse(JSON.stringify(this.ruleForm))
          
          if (formData.roleId && formData.roleId.length > 0) {
            formData.roleId = formData.roleId.join(",");
          } else {
            formData.roleId = "";
          }
          // 处理地区数据
          if (formData.regionId instanceof Array) {
            let regionId = formData.regionId[formData.regionId.length - 1];
            formData.regionId = regionId;
          }
          // 处理职称

          if (formData.professionalSkillPostId) {
            formData.rank=formData.professionalSkillPostId
            let obj = this.jobTitleOptions.find(item => {
              return item.id == formData.professionalSkillPostId
              
            })
            formData.professionalSkillPostName = obj.name

          }

          console.log('处理后的用户数据', formData);
          if (this.actionType === '新建用户') {
            this.addUser(formData);
          } else {
            this.editUser(formData)
          }
        } else {
          this.$message.error('表单验证失败！')
        }
      })
    },
    // 添加用户
    async addUser(data) {
      const res = await addUser(data);
      if (res.code == 200) {
        this.$message.success('添加成功！');
        this.$router.go(-1);
      } else {
        this.$message.error(res.data);
      }
    },
    // 修改用户
    async editUser(data) {
      const res = await editUser(data)
      if (res.code == 200) {
        this.$message({
          message: '修改成功！',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.go(-1)
          }
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    // 区域选择
    areaChange(val) {
      console.log(this.ruleForm.regionId) 
      if (val.length) {
        let areaId = val[val.length - 1];
        this.getUnitListByArea(areaId);
      } else {
        this.ruleForm.unitId = ''
        this.unitOptions = []
      }

    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.explain {
  padding: 0 15px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  line-height: 36px;
  color: #000;
}
</style>
